import React, { useEffect, useState } from "react";

import MasterTable from "../../../views/dashboard/widget/MasterTabel";
import AddHostelMenuMeal from "./add-hostel-menu-meal-form";
import { useParams } from "react-router-dom";
import { useGlobalState } from "../../../services/hostelConst.js";
import { getFoodMenuMealList, deleteFoodMenuMeal } from "./hostelServices/foodMenuServices";
const HostelMenuMealListTable = () => {
  const { toggleHostelMenu, openModal, modalState } = useGlobalState();
  var { id, foodMenuId } = useParams();
  
  var { foodMenuId } = useParams();
  useEffect(() => {
    openModal({ ...modalState, id: id, foodMenuId: foodMenuId });
    toggleHostelMenu(true);
    return () => {};
  }, []);

  return (
    <div>
      <MasterTable
        getTableData={getFoodMenuMealList}
        tab1={"Hostel"}
        tab2={"Meals"}
        hostelId={id}
        menuId={foodMenuId}
        AddForm={AddHostelMenuMeal}
        deleteRow={deleteFoodMenuMeal}
        actions={{
          edit:true,
          delete: true,
        }}
      />
    </div>
  );
};

export default HostelMenuMealListTable;
